import type { FC } from 'react';

import {
  AutoplayControlsContainer,
  AutoplayControlsRow,
} from '@pp/core/src/components/game/autoplayV2/controls/AutoplayControlsLayout';
import { CrashAutoplayStartButtonConnected } from './autoplayButtons/CrashAutoplayStartButtonConnected';
import { useCrashAutoplaySlice } from '../../../store/slices/crashAutoplay/selectors';
import { Bets } from '../../../config/bets';

export const CrashAutoplayInactiveControlsConnected: FC<{ betId: Bets; launchAutoplay: (round: number) => void }> = ({
  betId,
  launchAutoplay,
}) => {
  const roundOptions = useCrashAutoplaySlice.getAutoplayRoundsOptions(betId);
  const isInProgress = useCrashAutoplaySlice.isInProgress(betId);

  return (
    <AutoplayControlsContainer hidden={isInProgress}>
      {[0, 2].map((startIndex) => (
        <AutoplayControlsRow key={`row-${startIndex}`}>
          {roundOptions.slice(startIndex, startIndex + 2).map((option) => (
            <CrashAutoplayStartButtonConnected
              betId={betId}
              count={option}
              key={option}
              handleClick={() => {
                launchAutoplay(option);
              }}
            />
          ))}
        </AutoplayControlsRow>
      ))}
    </AutoplayControlsContainer>
  );
};
